import { Stack, Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { SourceTypeCard } from './SourceTypeCard';
import type { SourceType } from './types';

type Props = {
  onSelectSourceType: (type: SourceType) => void;
};

export const SourceTypeSelection = ({ onSelectSourceType }: Props) => {
  return (
    <Stack gap="xs">
      <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="gray.10">
        How would you like to structure the meeting note?
      </Text>
      <Stack gap="xxs">
        <SourceTypeCard
          title="Use a template"
          description="Generate meeting notes using a predefined template"
          onSelect={() => onSelectSourceType('template')}
        />
        <SourceTypeCard
          title="Use an agenda"
          description="Generate meeting notes using an uploaded agenda file as the structure"
          onSelect={() => onSelectSourceType('agenda')}
        />
      </Stack>
    </Stack>
  );
};
